export const OFFICES = ['stockholm', 'gothenburg', 'lisbon'] as const;
export const LOCALE = 'en-GB';
